import React from 'react';
import { Outlet } from 'react-router-dom';
import ResidentSideDrawar from './ResidentSideDrawar';
import BottomNav from '../BottomNav';
import { useMediaQuery, useTheme } from '@mui/material';

function ResidentDashLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const styles = `
  .layout-container {
    display: flex;
  }

  .main-content {
    flex-grow: 1;
    padding-top: 35px;
    margin-top: 5px;
    margin-inline: 0px;
  }

  @media (max-width: 768px) {
    .layout-container {
      display: block;
    }

    .main-content {
      flex-grow: 0;
      padding-top: 0px;   
      padding-bottom: 56px;
      margin-top: 0px;
    }
  }
`;

  return (
    <>
      <style>{styles}</style>
      <div className="layout-container">
        <ResidentSideDrawar />
        {/* {!isMobile && <ResidentSideDrawar />} */}
        <main className="main-content">
          <Outlet />
        </main>
        {isMobile && <BottomNav />} {/* Show bottom nav on mobile */}
      </div>
    </>
  );
}

export default ResidentDashLayout;
